import { AbsoluteFill, Easing, interpolate, useCurrentFrame } from 'remotion';

// 0.8s page-lift: dark curtain sweeps in + gold flash + curtain sweeps out
export const ThemeTransitionComposition: React.FC = () => {
  const frame = useCurrentFrame();

  // Gold flash hits at frame 3, gone by 18
  const flashOpacity = interpolate(frame, [0, 3, 18], [0, 0.45, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  // Scale: 1 → 1.03 → 0.98 → 1 (page-lift feel)
  const scale = interpolate(frame, [0, 10, 22, 36, 48], [1, 1.03, 0.98, 1.01, 1.0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  // Curtain sweep-in: 100% → 0% (slide down into frame)
  const curtainIn = interpolate(frame, [0, 14], [100, 0], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
    easing: Easing.bezier(0.76, 0, 0.24, 1),
  });

  // Curtain sweep-out: 0% → -100% (slide up out of frame)
  const curtainOut = interpolate(frame, [34, 48], [0, -100], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
    easing: Easing.bezier(0.76, 0, 0.24, 1),
  });

  // Blend: in-phase dominates first half, out-phase second half
  const curtainY = frame <= 24 ? curtainIn : curtainOut;

  return (
    <AbsoluteFill>
      {/* Dark curtain */}
      <AbsoluteFill
        style={{
          background: '#050505',
          transform: `translateY(${curtainY}%)`,
        }}
      />
      {/* Gold flash on top */}
      <AbsoluteFill
        style={{
          background: `rgba(212, 175, 55, ${flashOpacity})`,
          transform: `scale(${scale})`,
        }}
      />
    </AbsoluteFill>
  );
};
